export const typeOptions = [
  { value: "individual", label: "Individual Staff" },
  { value: "group", label: "Group of Staff" },
];
